 import {Component} from '@angular/core';

  @Component({
    templateUrl: './find-location-entry.component.html'
  })
  export class FindLocationEntryComponent {}
  